<template>
    <section class="recommend">
        <div>
            <v-tabs v-model="tab"
                    next-icon="mdi-arrow-right-bold-box-outline"
                    prev-icon="mdi-arrow-left-bold-box-outline"
                    show-arrows>
                <v-tabs-slider></v-tabs-slider>
                <v-tab v-for="item in items">
                    <span>
                           {{ item.label }}
                    </span>
                </v-tab>
            </v-tabs>

            <v-tabs-items v-model="tab">
                <v-tab-item v-for="item in items">
                    <v-card flat>
                        <div class="recommend__content">
                            <div class="recommend__img">
                                <img :src="item.src" alt="">
                            </div>
                            <div class="recommend__descr">
                                <div class="recommend__features" v-for="(feature, id) in item.features" :key="id">
                                    <div class="recommend__feature">
                                        <img :src="feature.url" alt="">
                                        <div>{{ feature.name }}</div>
                                    </div>
                                    <div class="recommend__characteristic">{{ feature.characteristic }}</div>
                                </div>
                                <a class="recommend__btn btn-red " :href="item.url">Подробнее</a>
                            </div>

                        </div>
                    </v-card>
                </v-tab-item>
            </v-tabs-items>
        </div>

    </section>
</template>

<script>
export default {
    props: {
        recommended: Array | String | Number | Boolean | Object,
    },
    name: "recommend",
    data() {
        return {
            tab: null,
            /*items: [
                {
                    label: "Лоток",
                    src: "/upload/iblock/90a/g9080m5ze1h17w3t39mtk6wvw9lozhlt/Kotlety-Krylya-Sborka.png",
                    url: "#",
                    features: [
                        {
                            url: '/upload/feature-1.svg',
                            name: 'Тип упаковки',
                            characteristic: 'Рулонная'
                        },
                        {
                            url: '/upload/feature-2.svg',
                            name: 'Материал',
                            characteristic: 'Полипропилен'
                        },
                        {
                            url: '/upload/feature-3.svg',
                            name: 'Цвет',
                            characteristic: 'Прозрачный'
                        },
                    ]
                },
                {
                    label: "Продукт 2",
                    src: "/upload/iblock/90a/g9080m5ze1h17w3t39mtk6wvw9lozhlt/Kotlety-Krylya-Sborka.png",
                    url: "#",
                    features: [
                        {
                            url: '/upload/feature-1.svg',
                            name: 'Тип упаковки',
                            characteristic: 'Рулонная'
                        },
                        {
                            url: '/upload/feature-2.svg',
                            name: 'Материал',
                            characteristic: 'Полипропилен'
                        },
                        {
                            url: '/upload/feature-3.svg',
                            name: 'Цвет',
                            characteristic: 'Прозрачный'
                        },
                    ]
                },
                {
                    label: "Продукт 3",
                    src: "/upload/iblock/90a/g9080m5ze1h17w3t39mtk6wvw9lozhlt/Kotlety-Krylya-Sborka.png",
                    url: "#",
                    features: [
                        {
                            url: '/upload/feature-1.svg',
                            name: 'Тип упаковки',
                            characteristic: 'Рулонная'
                        },
                        {
                            url: '/upload/feature-2.svg',
                            name: 'Материал',
                            characteristic: 'Полипропилен'
                        },
                        {
                            url: '/upload/feature-3.svg',
                            name: 'Цвет',
                            characteristic: 'Прозрачный'
                        },
                    ]
                },
                {
                    label: "Продукт 24",
                    src: "/upload/iblock/90a/g9080m5ze1h17w3t39mtk6wvw9lozhlt/Kotlety-Krylya-Sborka.png",
                    url: "#",
                    features: [
                        {
                            url: '/upload/feature-1.svg',
                            name: 'Тип упаковки',
                            characteristic: 'Рулонная'
                        },
                        {
                            url: '/upload/feature-2.svg',
                            name: 'Материал',
                            characteristic: 'Полипропилен'
                        },
                        {
                            url: '/upload/feature-3.svg',
                            name: 'Цвет',
                            characteristic: 'Прозрачный'
                        },
                    ]

                },

            ]*/
            items: this.recommended,
        }
    },
    methods: {}
}
</script>


<style scoped lang="scss">

.recommend {

  &__content {
    display: grid;
    grid-template-columns: 1fr 1fr;
    gap: 8px;

    @media (max-width: 1400px) {
      grid-template-columns: 1fr;
    }
  }

  &__descr {
    border: 1px solid #E8E8E8;
    border-radius: 40px;
    padding: 32px;


    @media (max-width: 766px) {
      width: 100%;
      min-height: 238px;
    }
  }


  &__img {
    border: 1px solid #E8E8E8;
    border-radius: 40px;
    display: flex;
    align-items: center;
    justify-content: center;

    & img {
      border-radius: 32px;
      width: auto;
      height: 100%;
      max-height: 420px;
      object-fit: cover;

      @media (max-width: 1400px) {
        max-width: unset;
        object-fit: cover;
        height: auto;
      }

      @media (max-width: 425px) {
        max-height: 200px;
      }

    }
  }

  &__features {
    display: flex;
    align-items: center;
    justify-content: space-between;
    gap: 15px;
    padding: 20px 0;
    border-bottom: 1px solid #EBEBEB;

    &:first-of-type {
      padding-top: 0;
    }

    &:last-of-type {
      margin-bottom: 60px;
    }

    @media (max-width: 650px) {
      display: grid;
      grid-template-columns: 1fr;
    }
  }

  &__feature,
  &__characteristic {
    font-family: 'RobotoRegular';
    font-weight: 400;
    font-size: 28px;
    line-height: 40px;
    letter-spacing: 0px;
    color: #212424;

    @media (max-width: 500px) {
      font-size: 22px;
      line-height: 30px;
    }
  }

  &__feature {
    display: flex;
    align-items: center;
    gap: 20px;
  }

  &__characteristic {
    color: #7D7D7D;
  }

  &__btn {
    max-width: max-content;
  }


}
</style>
